// Entry point for the build script in your package.json
import "bootstrap/js/dist/carousel"
import "bootstrap/js/dist/modal"
import "@hotwired/turbo-rails"

import { ready, initPasswordToggles, initToasts } from "./ui/shared"
import { initStoreUi } from "./ui/store"
import "./controllers"
import "./ui/analytics"

ready(() => {
  initPasswordToggles()
  initToasts()
  initStoreUi()
})

document.addEventListener("turbo:frame-load", () => {
  initStoreUi()
})
